<template>
  <div class="clearfix p2 darkblue-background white darkblue gibson mb2" v-if="show">
    <div class="col-12 p2">
      <p class="h4 semi-bold gibson white">
        Opgrader dit abonnement
      </p>
      <p class="h5 regular gibson white line-height-golden my2">
        Ønsker du at modtage kvalificerede kundehenvendelser? Så kan du tilkøbe adgang til dette.
      </p>
      <div class="py1"></div>
      <button class="col-12 white-ghost-button p2 gibson h5 semi-bold not-rounded" href="#/inbox?send=support&default=imentor">
        <span>Kontakt os her</span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'imentor',
  props: [
  ],
  data () {
    return {
      show: false
    }
  },
  created () {
    if (localStorage.getItem('imentor') === '0') {
      this.show = true
    }
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// imentor.vue?5cebd13a